import React from "react";

function AssignTrackingId({ isOpen, onClose, data, setData, onSubmit }) {

    const handleInputChange = (orderId, trackingId) => {
        setData((prev) =>
            prev.map((item) =>
                item.orderId === orderId ? { ...item, orderTrackingId: trackingId } : item
            )
        );
    };

    if (!isOpen) return null;

    return (
        <>
            <div className="modal-overlay">
                <div style={{ width: "60%", backgroundColor: "white", padding: "10px", maxHeight: "100vh", overflow: "scroll" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr>
                                <th style={{ border: "1px solid #ddd", padding: "8px" }}>Order ID</th>
                                <th style={{ border: "1px solid #ddd", padding: "8px" }}>Tracking ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.map((row, index) => (
                                <tr key={index}>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{row.orderId}</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                        <input
                                            type="text"
                                            placeholder="Enter Tracking ID"
                                            value={row.orderTrackingId}
                                            onChange={(e) => handleInputChange(row.orderId, e.target.value)}
                                            style={{
                                                width: "100%",
                                                padding: "6px",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                            }}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "10px", marginBottom: "10px" }}>
                        <button style={{ padding: "10px", marginRight: "10px", backgroundColor: "green", color: "white", cursor: "pointer" }} onClick={onSubmit} >Submit</button>
                        <button style={{ padding: "10px", marginRight: "10px", backgroundColor: "red", color: "white", cursor: "pointer" }} onClick={onClose}>cancel</button>
                    </div>
                </div>
            </div>
        </>
    )
}
export { AssignTrackingId }